module.exports = __webpack_public_path__ + "img/dag_no.db1947da.png";